import React from 'react';

function PageIllustration() {
  return (
    <svg className="absolute top-0 right-0 transform translate-x-1/2 -mr-16 dark:opacity-40" width="800" height="502" fill="none" xmlns="http://www.w3.org/2000/svg">
	  
      <circle cx="400" cy="102" r="400" fill="url(#heroglow_paint0_radial)" fillOpacity=".6" />
      <defs>
        <radialGradient id="heroglow_paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(90 149 251) scale(315.089)">
          <stop stopColor="#e11d48" />
          <stop offset="1" stopColor="#e11d48" stopOpacity=".01" />
        </radialGradient>
        
      </defs>
    </svg>

  );
}
export default PageIllustration;
